define('utils/constants',{
  root_url: 'https://www.id.net',
  tracking_url: 'http://cdn.id.net/api/tracking.html',
  analytics_url: 'https://t.id.net/log',
  playtomic_url: 'https://playtomic.id.net/v1',
  cdnUrl: 'https://scdn.id.net',
  y8_appid: '4fbb62b133968d57c10041b0',
  iframe_width: 433,
  iframe_height: 300,
  name_helper_url: 'https://scdn.id.net/Xd/name.html',
  xd_handler_helper_url: 'https://scdn.id.net/Xd/xd_handler.html?version=36' + '',
  assetsRootUrl: function(){
    if (document.location.protocol == 'https:')
      {
         return 'https://scdn.id.net'
      }
      else
      {
        return 'http://cdn.id.net'
      }
  }
});

